export const data = [
  {
    id: "card1",
    img: require("./image/prosperity.jpg"),
    title: "Increasing Prosperity With Positive Thinking",
    tags: ["Art", "Design"],
    date: "12/12/2020",
    desc: "Increasing prosperity in our lives can be accomplished by having the right frame of mind. The truth is, our thoughts are very powerful. They are capable of influencing every aspect of our daily lives, from our physical health to our social behaviors. I'm sure you've heard the adage, 'As you think, so shall you be.'",
  },
  {
    id: "card2",
    img: require("./image/motivation.png"),
    title: "Motivation Is The First Step To Success",
    tags: ["Culture"],
    date: "12/11/2021",
    desc: "Knowing yourself is the first, and a very critical step in the process of planning your future. How can you figure out what you want to do with your life if you don’t know: What am I going to do with the  rest of my life? What is my dream job? What do I enjoy doing? What’s my passion? What kind of career fits my personality?",
  },
  {
    id: "card3",
    img: require("./image/success.jpg"),
    title: "Success Steps For Your Personal Or Business Life",
    tags: ["Art", "Culture"],
    date: "1/2/2020",
    desc: "Don’t forget the preparation. Success needs hard work. Successful people do not see failures as failures.Just set something gratifying to indulge in after completing a certain undertaking. If you want to succeed, surround yourself with the right kind of people who will support and encourage you all the way.",
  },
  {
    id: "card4",
    img: require("./image/teamwork.png"),
    title: "Learn to tell stories",
    tags: ["Art", "Culture"],
    date: "12/1/2019",
    desc: "People love stories because they connect them with themselves on an emotional level. Marketers who know how to tell great stories in their marketing campaigns achieve outstanding results. Read more and be comprehensively developed. This will help you to find unusual ideas.",
  },
  {
    id: "card5",
    img: require("./image/performance.jpg"),
    title: "Define performance indicators",
    tags: ["Art", "Design"],
    date: "12/03/2022",
    desc: "Marketing is not the same as ten years ago. Today, companies want to understand what exactly the budget went for. Therefore, it is important before marketing activities to determine goals and performance indicators. So you will improve the results and be able to convey to your leadership your value as a frame. Often reports are provided monthly, indicators should be clear and clearly demonstrate the results.",
  },
  {
    id: "card6",
    img: require("./image/time.jpg"),
    title: "Time management",
    tags: ["Art", "Culture"],
    date: "2/2/2020",
    desc: "Good specialists are able to correctly plan projects and create a schedule for completion of work. Therefore, they complete tasks on time. They know how to properly allocate resources and ensure the specified launch date, relate to it with trepidation and do everything possible to ensure that everything is done on time.",
  },
  {
    id: "card7",
    img: require("./image/income.jpg"),
    title: "Focus on income",
    tags: ["Design", "Culture"],
    date: "12/4/2018",
    desc: "Marketers focused on generating revenue for the company are in great demand. Therefore, if all your efforts are aimed precisely at this, you will find great success. According to a study by  Fournaise Marketing Group, 78% of managers believe that marketing is not focused on achieving financial performance. Link marketing activities with analytics, consider the short-term and long-term goals of the enterprise, and you will become a good professional in this field. ",
  },
  {
    id: "card8",
    img: require("./image/workdata.jpg"),
    title: "Work with data",
    tags: ["Culture", "Design"],
    date: "22/06/2020",
    desc: "Learn how to use the data for your own purposes. Master your analytics tools, improve your Excel knowledge. In the coming decades, employers will look for just such specialists who can work with a huge array of data and use it to develop their business and achieve financial performance.",
  },
];
